import { useContext } from 'react';
import { CommentEditorContext, EditorContext } from '../context';
import { useIsCommentEditorEmpty } from './useIsCommentEditorEmpty';
/**
 * Returns `true` if the editor contains valid text that we can submit, regardless of if the user is
 * using the full featured editor or the fallback editor.
 */
export function useIsCommentEditorSubmittable() {
    var isEmpty = useIsCommentEditorEmpty();
    var _a = useContext(CommentEditorContext), isBusy = _a.isBusy, submitValidator = _a.submitValidator;
    var editorState = useContext(EditorContext).state;
    if (submitValidator && editorState) {
        return submitValidator(editorState);
    }
    return !isEmpty && !isBusy;
}
//# sourceMappingURL=useIsCommentEditorSubmittable.js.map